<div class="flex w-full h-full p-6 gap-6 bg-surface-50 flex-col">
  <p-card>
    <div class="text-text-color text-xl font-medium">Notifications</div>
    <div class="w-full border-surface-300 border-[1px]"></div>
    <div class="flex-col gap-2 flex-1 mt-2 mb-2 w-[50%]">
      <p-fieldset legend="SMTP Settings" class="">
        <div class="self-stretch justify-start"><span class="text-text-color text-sm font-normal font-['Inter'] leading-5">Host</span></div>
        <input pInputText fluid placeholder="SMTP Host" [(ngModel)]="emailSettings()['Email_Smtp_Host']"/>
        <div class="self-stretch justify-start"><span class="text-text-color text-sm font-normal font-['Inter'] leading-5">From</span></div>
        <input pInputText fluid placeholder="From address" [(ngModel)]="emailSettings()['Email_FromAddress']"/>
        <div class="self-stretch justify-start"><span class="text-text-color text-sm font-normal font-['Inter'] leading-5">Compliance/Payroll Email Address</span></div>
        <input pInputText fluid placeholder="Compliance/Payroll Email Address" [(ngModel)]="emailSettings()['Email_ComplianceAddress']"/>
        <div class="self-stretch justify-start"><span class="text-text-color text-sm font-normal font-['Inter'] leading-5">Enabled</span></div>
        <p-toggleswitch [ngModel]="emailEnabled()" (onChange)="emailEnabled.set($event.checked)" />
        <div class="flex flex-row gap-10 mt-2 mb-2">
          <p-button (click)="saveEmailSettings()" >Save</p-button>
        </div>
      </p-fieldset>
      <div class="w-full border-surface-300 border-[1px] mt-2 mb-2"></div>
      <div class="flex flex-row gap-1 mt-2 mb-2">
        <p-button (click)="triggerTestEmail()">Test Email</p-button>
        <div class="w-12" [pTooltip]="'Send a test email to yourself'">
          <i class="fa-regular fa-circle-question fa-xl text-primary"></i>
        </div>
      </div>
    </div>
  </p-card>
  <p-card>
    <div class="flex flex-col gap-4">
      <div class="text-text-color text-xl font-medium">System</div>
      <div class="w-full border-surface-300 border-[1px]"></div>

      <div class="flex flex-row mt-2 mb-2">
        <a routerLink="/admin/auditlog" pButton>
          Audit Log
        </a>
      </div>

      <div class="text-text-color text-base font-medium">Job Status</div>
      <div class="rounded-lg border-[1px] border-surface-300 w-fit min-w-[60%]">
        <p-table [value]="jobStatusList()" size="small">
          <ng-template #header>
            <tr>
              <th>Job</th>
              <th>Status</th>
              <th>Start</th>
              <th>End</th>
              <th>Duration</th>
              <th>Error</th>
            </tr>
          </ng-template>
          <ng-template #body let-rowData>
            <tr>
              <td>{{ rowData.jobDisplayName }}</td>
              <td>
                <p-tag rounded [severity]="jobStatusSeverity(rowData.status)" [value]="rowData.status" />
              </td>
              <td><span class="text-nowrap">{{ (rowData.lastStarted | date:'dd/MM/yy h:mm:ss a') ?? '-' }}</span></td>
              <td><span class="text-nowrap">{{ (rowData.lastEnded | date:'dd/MM/yy h:mm:ss a') ?? '-' }}</span></td>
              <td>{{ formatDuration(rowData.lastStarted, rowData.lastEnded) }}</td>
              <td>{{ rowData.lastError ?? '-' }}</td>
            </tr>
          </ng-template>
          <ng-template #emptymessage>
            <tr>
              <td colspan="6" class="text-slate-500 text-sm italic">No jobs have run yet.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </p-card>

</div>
